module.exports = __webpack_public_path__ + "img/variant-default-img.19c82578.svg";